'use strict';

import $ from 'jquery';
import StripeForm from '@/js/modules/stripe_form';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if ($('body').is('#update-cc')) {
      const stripeForm = new StripeForm();
      $(document).on('click', '.p-button--update-cc', (e) => {
        const $button = $(e.target);
        const $form = $(e.target).closest('form');
        $button.addClass('button-loading');

        stripeForm.submit().then((result) => {
          if (result.token) {
            $form.find('#stripe_token').val(result.token.id);
            $form.submit();
          } else {
            $button.removeClass('button-loading');
          }
        });

        return false;
      });
    }
  });
});
